import { classNames, twMerge } from '@panwds/tailwindcss';
import React, {} from 'react';
import TabsContext from './TabsContext.js';
const TabsMain = ({ orientation = 'horizontal', dataTestId = 'tabs', dataMetrics = 'tabs-metrics', addClassName, children }) => {
    const isVertical = orientation === 'vertical';
    return (React.createElement("div", { "data-metrics": dataMetrics, className: classNames('twds-flex twds-min-h-80 twds-min-w-80 twds-w-full twds-h-full') },
        React.createElement("div", { "data-testid": dataTestId, className: twMerge('twds-flex twds-font-lato twds-relative twds-w-full twds-h-full', !isVertical && 'twds-flex-col', addClassName) }, children)));
};
export const Tabs = (props) => {
    const { orientation, children, draggable } = props;
    const context = { orientation, draggable };
    return (React.createElement(TabsContext.Provider, { value: context },
        React.createElement(TabsMain, { ...props }, children)));
};
//# sourceMappingURL=Tabs.js.map